<template>
  <div
    :class="message.displayClass"
    :title="messageTimeLocalize"
  >
    <span class="actor">{{ message.actor }}</span>
    <br>
    <div
      class="
        mb-0
        rounded
        text-white
        p-3
        d-inline-block
        message
        text-left text-wrap
        w-100
      "
    >
      <div class="caret" />
      {{ message.message }}
    </div>
    <br>
    <span class="time text-muted">{{ messageTimeHumanize }}</span>
  </div>
</template>
<script>
import moment from 'moment-timezone';

export default {
  name: 'UserMessage',
  props: {
    message: { default: null, required: true },
  },
  computed: {
    messageTimeHumanize() {
      return moment(this.message.created_at).fromNow();
    },
    messageTimeLocalize() {
      return moment(this.message.created_at).format('LLLL');
    },
  },
  created() {
    moment.locale('th');
  },
};
</script>
<style lang="scss" scoped>
.receive {
  max-width: 80%;
  margin-right: 20%;
  margin-bottom: 0.5rem;
  position: relative;
  .message {
    background-color: var(--secondary);
  }
  .caret {
    display: block;
    position: absolute;
    left: 0;
    top: -0.25rem;
    border: 0.5rem solid var(--secondary);
    border-right-color: transparent;
    border-top-color: transparent;
  }

  .actor {
    font-size: 0.85rem;
  }
}
.send {
  max-width: 80%;
  margin-left: 20%;
  text-align: right;
  margin-bottom: 0.5rem;
  position: relative;
  .actor {
    display: none;
  }

  .message {
    background-color: var(--green);
  }
  .caret {
    display: block;
    position: absolute;
    right: 0;
    bottom: -0.25rem;
    border: 0.5rem solid var(--green);
    border-left-color: transparent;
    border-bottom-color: transparent;
  }
}
.message {
  position: relative;
}
.time {
  font-size: 0.75em;
}
</style>
